<template>
  <div class="gd612-status-bar" type="flex">
    <div class="common-border">
      <el-row type="flex" justify="center" align="middle" class="pump-status common-border2">
        <el-col tag="span" :span="5">
          <span class="iconfont icon-alarmstate"></span>
          报警状态：
          <span :class="alarmStatus | alarmClass">{{ alarmStatus | alarmText }}</span>
        </el-col>

        <el-col tag="span" :span="5">
          <span class="iconfont icon-runstate"></span>
          运行状态：
          <span :class="runState | runClass">{{ runState | runText }}</span>
        </el-col>

        <el-col tag="span" :span="5">
          <span class="iconfont icon-diedaobaojing"></span>
          跌倒报警：
          <span :class="tumble | tumbleClass">{{ tumble | tumbleText }}</span>
        </el-col>

        <el-col tag="span" :span="5">
          <span class="iconfont icon-humidity2"></span>
          相对湿度：{{ humidity }}%
        </el-col>
        <el-col tag="span" :span="5">
          <span class="iconfont icon-temperature2"></span>
          温度：{{ temperature }}℃
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { tools } from '../utils';

export default {
  props: {
    alarmStatus: {
      type: Number,
      default: 0
    },
    runState: {
      type: Number,
      default: 0
    },
    tumble: {
      type: Number,
      default: 0
    },
    humidity: {
      type: Number,
      required: true
    },
    temperature: {
      type: Number,
      requires: true
    }
  },
  filters: tools
};
</script>

<style lang="scss">
.gd612-status-bar {
  padding-top: var(--status-bar-mt);

  .pump-status {
    height: var(--status-bar-height);
  }
  .overall-status {
    font-weight: bold;
  }
  .el-col {
    font-size: var(--status-bar-fs);
    padding-left: 20px;
    text-align: center;
  }
}
</style>
